export default __webpack_public_path__ + "static/media/ImagePlaceholder.da8af9b4.svg";